import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@ADDRESS', (value: string, c11nEnv: C11nEnv) => {
  const country = c11nEnv.getValue(value)?.pyCountry;

  if (!country) {
    return 'pyAddressForm';
  }

  return `pyAddressForm_${country}`;
});
